.bottom-button {
  width: 100%;
  height: 40px;
  border-radius: var(--fdt-core-borderradius-medium);
  cursor: pointer;
  justify-content: center;
  margin-top: 10px;
}

.quick-view-footer {
  padding-top: 10px;
}

.attributes-section {
  margin-top: 20px;
  width: 100%;
  padding-right: 10px;
}
.attributes-section h6 {
  margin-bottom: 12px;
  color: #1a1a1d;
}
.attributes-section .attributes-table {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-right: 20px;
  border: 1px solid #e0e0e0;
  border-radius: var(--fdt-core-borderradius-medium);
  width: 100%;
}
.attributes-section .attribute-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 10px;
}
.attributes-section .attribute-row .attr-label {
  font-weight: 600;
  color: #1a1a1d;
}
.attributes-section .attribute-row .attr-value {
  color: #1a1a1d;
}
.attributes-section .attribute-row.even {
  background-color: #fff;
}
.attributes-section .attribute-row.odd {
  background-color: #f9f9fb;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiQzpcXGlvXFxldGV4LWh1YnN0ZXJcXHNyY1xcRnJvbnRlbmRcXGhlYWRsZXNzXFxtb2R1bGVzXFxldGV4XFxzcmNcXGNvbXBvbmVudHNcXHNsaWRlb3V0XFxxdWljay12aWV3LXBhbmVsIiwic291cmNlcyI6WyJxdWlja1ZpZXcuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFFRjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLmJvdHRvbS1idXR0b24ge1xyXG4gIHdpZHRoOiAxMDAlO1xyXG4gIGhlaWdodDogNDBweDtcclxuICBib3JkZXItcmFkaXVzOiB2YXIoLS1mZHQtY29yZS1ib3JkZXJyYWRpdXMtbWVkaXVtKTtcclxuICBjdXJzb3I6IHBvaW50ZXI7XHJcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XHJcbiAgbWFyZ2luLXRvcDogMTBweDtcclxufVxyXG5cclxuLnF1aWNrLXZpZXctZm9vdGVyIHtcclxuICBwYWRkaW5nLXRvcDogMTBweDtcclxufVxyXG5cclxuLmF0dHJpYnV0ZXMtc2VjdGlvbiB7XHJcbiAgbWFyZ2luLXRvcDogMjBweDtcclxuICB3aWR0aDogMTAwJTtcclxuICBwYWRkaW5nLXJpZ2h0OiAxMHB4O1xyXG5cclxuICBoNiB7XHJcbiAgICBtYXJnaW4tYm90dG9tOiAxMnB4O1xyXG4gICAgY29sb3I6ICMxYTFhMWQ7XHJcbiAgfVxyXG5cclxuICAuYXR0cmlidXRlcy10YWJsZSB7XHJcbiAgICBkaXNwbGF5OiBmbGV4O1xyXG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcclxuICAgIG92ZXJmbG93OiBoaWRkZW47XHJcbiAgICBtYXJnaW4tcmlnaHQ6IDIwcHg7XHJcbiAgICBib3JkZXI6IDFweCBzb2xpZCAjZTBlMGUwO1xyXG4gICAgYm9yZGVyLXJhZGl1czogdmFyKC0tZmR0LWNvcmUtYm9yZGVycmFkaXVzLW1lZGl1bSk7XHJcbiAgICB3aWR0aDogMTAwJTtcclxuICB9XHJcblxyXG4gIC5hdHRyaWJ1dGUtcm93IHtcclxuICAgIGRpc3BsYXk6IGdyaWQ7XHJcbiAgICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDFmciAxZnI7XHJcbiAgICBwYWRkaW5nOiAxMHB4O1xyXG5cclxuICAgIC5hdHRyLWxhYmVsIHtcclxuICAgICAgZm9udC13ZWlnaHQ6IDYwMDtcclxuICAgICAgY29sb3I6ICMxYTFhMWQ7XHJcbiAgICB9XHJcblxyXG4gICAgLmF0dHItdmFsdWUge1xyXG4gICAgICBjb2xvcjogIzFhMWExZDtcclxuICAgIH1cclxuXHJcbiAgICAmLmV2ZW4ge1xyXG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmO1xyXG4gICAgfVxyXG4gICAgJi5vZGQge1xyXG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZjlmOWZiO1xyXG4gICAgfVxyXG4gIH1cclxufVxyXG4iXX0= */